import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, Typography } from '@mui/material';
import { DdxState } from '../../../../../store/planStore';
import { formatBudget } from '../../MediaPlansTable/ComparedPlansModal/helpers';

interface DDXInfoRowProps {
  currency?: string;
  ddx?: DdxState;
}

function DDXInfoRow({ ddx, currency }: DDXInfoRowProps) {
  const { t } = useTranslation();

  return (
    <TableRow
      sx={{ borderBottom: 'none', height: '70px', background: '#F2F8FF' }}
    >
      <TableCell />
      <TableCell align="left">
        <Typography variant="body2" fontWeight={700} textTransform="uppercase">
          TOTAL DDX
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2" fontWeight={700}>
          {formatBudget(ddx?.totalDDX, currency)}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default DDXInfoRow;
